import { useEffect, useState } from "react";

export default function ModalPopup({
  titleName,
  content,
  isOpen,
  onClose,
  hasButtonClose = false,
  onNo,
  onYes,
  noFooter = false,
  msg,
}) {
  const [visible, setVisible] = useState(false);
  const [rendered, setRendered] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setRendered(true);
      setTimeout(() => setVisible(true), 50);
    } else {
      setVisible(false);
      setTimeout(() => setRendered(false), 300);
    }
  }, [isOpen]);

  if (!rendered) return null;

  return (
    <div className="general_popup_container">
      <div
        className={`general_popup popup-transition ${
          visible ? "open" : "close"
        }`}
      >
        <div className="general_popup_title">
          <span>{titleName}</span>
          <span onClick={onClose} className="cursor-pointer">
            <div className="close_icon">
              <div/>
              <div/>
            </div>
          </span>
        </div>
        <div className="general_popup_content">
          <span>{content}</span>
        </div>
        {noFooter === false && (
          <div className="general_popup_footer">
            {hasButtonClose && (
              <button onClick={onClose} className="general_popup_close">
                {msg.close}
              </button>
            )}
            {typeof onNo === "function" && (
              <button onClick={onNo} className="general_popup_no">
                {msg.no}
              </button>
            )}
            {typeof onYes === "function" && (
              <button onClick={onYes} className="general_popup_yes">
                {msg.yes}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
